
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  SkillSuggestions,
  SkillSuggestionsRequest,
} from '../models';
import {
    SkillSuggestionsFromJSON,
    SkillSuggestionsToJSON,
    SkillSuggestionsRequestFromJSON,
    SkillSuggestionsRequestToJSON,
} from '../models';

export interface SuggestSignupSkillsRequest {
    skillSuggestionsRequest: SkillSuggestionsRequest;
}

/**
 * 
 */
export class SignupSkillSuggestionsApi extends runtime.BaseAPI {

    /**
     * Suggest skills from the signup draft work experiences and a description
          */
    async suggestSignupSkillsRaw(requestParameters: SuggestSignupSkillsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<SkillSuggestions>> {
        if (requestParameters['skillSuggestionsRequest'] == null) {
            throw new runtime.RequiredError(
                'skillSuggestionsRequest',
                'Required parameter "skillSuggestionsRequest" was null or undefined when calling suggestSignupSkills().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<SkillSuggestions>({
            path: `/profile/public-api/freelancer-signup/skill-suggestions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SkillSuggestionsRequestToJSON(requestParameters['skillSuggestionsRequest']),
        }, initOverrides);

        if (response._data) { response._data=SkillSuggestionsFromJSON(response._data); }
        return response;
    }

    /**
     * Suggest skills from the signup draft work experiences and a description
          */
    async suggestSignupSkills(requestParameters: SuggestSignupSkillsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<SkillSuggestions> {
        const response = await this.suggestSignupSkillsRaw(requestParameters, initOverrides);
        return response._data;
    }

}
